import React from 'react';

import { FormControl, Box, FormHelperText, TextField } from '@mui/material';

interface PlotNameFieldProps {
  value: string;
  error: string | boolean;
  setValue: (value: string) => void;
  setError: (error: string | boolean) => void;
  setChanged: () => void;
  [key: string]: unknown;
}

export default function PlotNameField({
  value,
  error,
  setValue,
  setError,
  setChanged,
  ...rest
}: PlotNameFieldProps): React.JSX.Element {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value: newValue } = event.target;
    setValue(newValue);
    setChanged();
    if (/[#^$<>+%!`&*'"|{}?/\\:=@]/.test(newValue)) {
      setError('Name cannot contain #^$<>+%!`&*\'"|{}?/\\:=@');
    } else if (newValue === '') {
      setError('Name cannot be blank');
    } else {
      setError(false);
    }
  };

  return (
    <Box>
      <FormControl fullWidth required>
        <TextField
          {...rest}
          label='Name'
          id='name'
          aria-describedby='name-helper-text'
          onChange={handleChange}
          error={Boolean(error)}
          value={value}
          variant='standard'
          required
        />
        {error ? (
          <FormHelperText id='name-helper-text'>{String(error)}</FormHelperText>
        ) : (
          <FormHelperText id='name-helper-text'>
            Enter the name of the plot.
          </FormHelperText>
        )}
      </FormControl>
    </Box>
  );
}

